// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2BYcK","content":"Consent_content__1qOh7","footer":"Consent_footer__U0-Ls"};